<template>
  <v-card
    class="pa-6 mb-6"
    style="border-radius: 18px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06)"
  >
    <v-card-title
      class="text-h6 font-weight-bold d-flex justify-space-between align-center"
    >
      <span>Ad Set Details</span>
      <div>
        <v-icon
          small
          @click="toggleEdit"
          style="font-size: 23px; margin-right: 1rem"
        >
          {{ isEditing ? "mdi-check" : "mdi-pencil" }}
        </v-icon>
        <v-icon small @click="expanded = !expanded" class="cursor-pointer">
          {{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </div>
    </v-card-title>

    <v-expand-transition>
      <div v-show="expanded">
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <!-- كل عنصر ياخد سطر كامل -->
              <v-col cols="12" class="mb-4">
                <div class="label">Ad set name</div>
                <div class="value">{{ store.adSetData.adSetName }}</div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="label">Performance goal</div>
                <div class="value">
                  {{ store?.adSetData.performanceGoal?.title }}
                </div>
              </v-col>

              <v-col cols="12" class="mb-4" v-if="store.adSetData.chargeType">
                <div class="label">When you are charged</div>
                <div class="value">{{ store.adSetData.chargeType }}</div>
              </v-col>

              <!-- <v-col cols="12" class="mb-4">
                <div class="label">Bid Control</div>
                <div class="value mt-2">
                  <div>


                  </div>
                </div>
              </v-col> -->

              <v-col cols="12" class="mb-4">
                <div class="label">Allow video sharing</div>
                <div class="value">
                  {{
                    store.adSetData.allowVideoSharing ? "Active" : "Inactive"
                  }}
                </div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="label">Status</div>
                <div class="value">
                  {{ store.adSetData.status ? "Active" : "Inactive" }}
                </div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="label">Age</div>
                <div class="value">
                  From {{ store.adSetData.ageFrom }} to
                  {{ store.adSetData.ageTo }}
                </div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="label">Genders</div>
                <div class="value">
                  {{ store.adSetData.selectedGender.toUpperCase() }}
                </div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="label">Languages</div>
                <div class="value">
                  {{
                    Array.isArray(store.adSetData.language)
                      ? store.adSetData.language.join(" - ")
                      : store.adSetData.language
                  }}
                </div>
              </v-col>
              <v-col cols="12" class="mb-4" v-if="localSelectedNames.length">
                <div class="label">Location</div>
                <div class="value">
                  <div
                    v-for="country in localSelectedNames"
                    :key="country.country_code"
                  >
                    <div>
                      <span
                        v-for="(region, index) in country.children"
                        :key="region.region_code"
                      >
                        {{ region.label
                        }}<span v-if="index < country.children.length - 1"
                          >,
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" class="mb-4" v-if="hasAnyInterests">
                <div class="label">Interests & behaviors</div>
                <div class="value mt-2">
                  <div
                    v-for="platform in ['facebook', 'snapchat', 'tiktok']"
                    :key="platform"
                    class="mb-2"
                  >
                    <template v-if="getInterestsByPlatform(platform).length">
                      <div class="d-flex align-center">
                        <img
                          :src="getPlatformIcon(platform)"
                          width="20"
                          height="20"
                          class="mr-2"
                        />
                        <strong>{{ getPlatformName(platform) }}:</strong>
                      </div>
                      <div class="ml-5 mt-1">
                        <span
                          v-for="(interest, index) in getInterestsByPlatform(
                            platform
                          )"
                          :key="interest.id"
                          class="d-inline-block mr-2"
                        >
                          {{ interest.label
                          }}<span
                            v-if="
                              index <
                              getInterestsByPlatform(platform).length - 1
                            "
                            >,</span
                          >
                        </span>
                      </div>
                    </template>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="label">Placements</div>
                <div class="value">Automatic Placement</div>
              </v-col>

              <v-col cols="12" class="mb-4" v-if="store.adSetData.brandSafety">
                <div class="label">Brand safety and suitability</div>
                <div class="value">{{ store.adSetData.brandSafety }}</div>
              </v-col>

              <v-col cols="12" v-if="store.adSetData.deliveryType">
                <div class="label">Delivery type</div>
                <div class="value">{{ store.adSetData.deliveryType }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
import facebookIcon from "@/components/SuperApp/ReviewPageIcon/meta.svg";
import snapchatIcon from "@/components/SuperApp/ReviewPageIcon/snap.svg";
import tiktokIcon from "@/components/SuperApp/ReviewPageIcon/tiktok.svg";

export default {
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    store() {
      return useSuperAddStore(); // ستورك هنا هو المصدر الرسمي
    },
    hasAnyInterests() {
      const platforms = ["facebook", "snapchat", "tiktok"];
      return platforms.some((p) => this.getInterestsByPlatform(p).length > 0);
    },
    localSelectedNames() {
      const raw = localStorage.getItem("selectedNames");
      try {
        return JSON.parse(raw) || [];
      } catch (e) {
        return [];
      }
    },
  },
  methods: {
    getInterestsByPlatform(platform) {
      if (!Array.isArray(this.store.adSetData.interestsMap)) return [];
      return this.store.adSetData.interestsMap.filter(
        (i) => i.platform === platform
      );
    },
    getPlatformIcon(platform) {
      switch (platform) {
        case "facebook":
          return facebookIcon;
        case "snapchat":
          return snapchatIcon;
        case "tiktok":
          return tiktokIcon;
        default:
          return "";
      }
    },
    getPlatformName(platform) {
      switch (platform) {
        case "facebook":
          return "Meta";
        case "snapchat":
          return "Snapchat";
        case "tiktok":
          return "TikTok";
        default:
          return "Unknown";
      }
    },
    toggleEdit() {
      console.log("eeeeee");
      this.$emit("onEdit", 1);
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
}
.value {
  font-size: 15px;
  color: #222;
}
.interests-text {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  flex: 1 1 auto;
}
</style>
